import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMUserResource from 'resources/SMUserResource';
import SMReservationResource from 'resources/SMReservationResource';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMReservationInvitationView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      errors: [],
    };
  }

  componentDidMount() {
  }

  signinDidSubmit(e) {
    e.preventDefault();
    const username = $(this.refs.signinForm.email).val();
    const password = $(this.refs.signinForm.password).val();
    SMUserResource.signin(username, password, (data, error, xhr) => {
      this.setState({user: data});
    });
  }

  signupDidSubmit(e) {
    e.preventDefault();
    const currentTarget = e.currentTarget;
    const formData = new FormData(currentTarget);
    const query = this.props.currentUser ? { id: this.props.currentUser.id } : {};
    $(currentTarget).startLoading();
    SMReservationResource.addGuestCompanion(this.props.reservation.id, formData, query, (data, error, xhr)=>{
      $(currentTarget).stopLoading();
      if (error) {
        if (xhr.responseJSON.errors) this.setState({errors: xhr.responseJSON.errors});
      } else {
        const params = this.props.currentUser ? {} : {user_id: data.username};
        SMAppHelper.redirectTo(Routes.replied_invitation_path(this.props.reservation.uid, params));
      }
    });
  }

  renderCorpName() {
    if (this.props.reservation.user.is_corp) {
      return(
        <span className="popup-header__company-name">（{this.props.reservation.user.corp_name}）</span>
      );
    } else {
      return null;
    }
  }

  onFileSelect(e) {
    var files = e.target.files;
    for (var i = 0; i< files.length; i++) {
      var file = files[i];
      $(this.refs.fileName).text(file.name);
    }
  }

  renderSigninForm() {
    if (this.props.currentUser) return null;
    return(
      <form action='/i/login' method='post'>
        <div className="popup-headline">
          <h3 className="popup-headline__title2">{I18n.t('service.text_000500')}</h3>
          <p className="popup-headline__text">{I18n.t('service.text_000501')}</p>
        </div>

        <input type="hidden" name='authenticity_token' value={$('meta[name="csrf-token"]')[0].content} />
        <div className="popup-login">
            <div className="popup-login__box clearfix">
              <div className="col-md-3">
                <h2 className="popup-login__title">
                  <span className="popup-login__title-text">{I18n.t('service.label_000500')}</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input ref='email' type="text" name="user[email]" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="email" withIcon={true} errorText={SMFormatHelper.errorText("User", "email", this.state.errors)} />
              </div>
            </div>
            <div className="popup-login__box clearfix">
              <div className="col-md-3">
                <h2 className="popup-login__title">
                  <span className="popup-login__title-text">{I18n.t('service.label_000501')}</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input ref='password' type="password" name="user[password]" id="user_contact_department" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="password" withIcon={true} errorText={SMFormatHelper.errorText("User", "password", this.state.errors)} />
              </div>
            </div>
        </div>

        <div className="ta-c mt20 mb20 clearfix">
          <div className="col-xs-12">
            <input type="submit" name="commit" value={I18n.t('service.label_000026')} className="button-blue pt15 pb15 w200" />
          </div>
        </div>
      </form>
    );
  }

  renderRegisterForm() {
    if (this.props.currentUser) {
      return(
        <form onSubmit={this.signupDidSubmit.bind(this)}>
          <div className="popup-headline">
            <h3 className="popup-headline__title2">{I18n.t('service.text_000500')}</h3>
            <p className="popup-headline__text">{I18n.t('service.text_000503')}<br />{I18n.t('service.text_000504')}</p>
          </div>
          <div className="row">
            {this.renderCertificateUploadField()}
            <div className="odd-col__line clearfix">
              <div className="ta-c mt20 mb20 clearfix">
                <div className="col-xs-12">
                  <input type="submit" name="commit" value={I18n.t('service.label_000502')} className="button-blue pt15 pb15 w200" />
                </div>
              </div>
            </div>
          </div>
        </form>
      );
    } else {
      return(
        <form onSubmit={this.signupDidSubmit.bind(this)}>
          <div className="popup-headline">
            <h3 className="popup-headline__title2">{I18n.t('service.text_000502')}</h3>
            <p className="popup-headline__text">{I18n.t('service.text_000504')}<br />{I18n.t('service.text_000505')}</p>
          </div>
          <div className="row">
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">{I18n.t('service.label_000504')}</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input placeholder="スペスマ 太郎" type="text" name="name" id="user_contact_corp_name" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="name" withIcon={true} errorText={SMFormatHelper.errorText("User", "name", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">{I18n.t('service.label_000500')}</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input placeholder="sample@spacemarket.co.jp" type="text" name="email" id="user_contact_corp_name" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="email" withIcon={true} errorText={SMFormatHelper.errorText("User", "email", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">{I18n.t('service.label_000501')}</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input type="password" name="password" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="password" withIcon={true} errorText={SMFormatHelper.errorText("User", "password", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">{I18n.t('service.label_000505')}</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input type="password" name="password_confirmed" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="password_confirmed" withIcon={true} errorText={SMFormatHelper.errorText("User", "password_confirmed", this.state.errors)} />
              </div>
            </div>
            {/*
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">姓名</span>
                </h2>
              </div>
              <div className="col-md-9">
                <div className="information-name">
                  <label>
                    <span className="popup-form__label">姓</span>
                    <input type="text" name="contact[family_name]" id="user_contact_family_name" className="form-text servicse-form-text" />
                  </label>
                  <SMFormValidationMessage name="contact[family_name]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.family_name", this.state.errors)} />
                </div>
                <div className="information-name">
                  <label>
                    <span className="popup-form__label">名</span>
                    <input type="text" name="contact[given_name]" id="user_contact_given_name" className="form-text servicse-form-text" />
                  </label>
                  <SMFormValidationMessage name="contact[given_name]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.given_name", this.state.errors)} />
                </div>
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__optional">任意</span>
                  <span className="popup-form__title-text">法人・団体名</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input placeholder="株式会社スペースマーケット" type="text" name="contact[corp_name]" id="user_contact_corp_name" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="contact[corp_name]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.corp_name", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__optional">任意</span>
                  <span className="popup-form__title-text">部署名・肩書</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input placeholder="人事部人事課 課長" type="text" name="contact[department]" id="user_contact_department" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="contact[department]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.department", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">郵便番号</span>
                </h2>
              </div>
              <div className="col-md-9">
                <label>
                  <span className="popup-form__label">ハイフンなしの半角数字。入力すると住所が自動補完されます</span>
                  <input maxLength="10" placeholder="1600023" size="10" type="text" name="contact[postal_code]" id="user_contact_postal_code" className="form-text servicse-form-text w110" />
                </label>
                <SMFormValidationMessage name="contact[postal_code]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.postal_code", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">都道府県・<br className="sm-hide" />市区町村</span>
                </h2>
              </div>
              <div className="col-md-9">
                <div className="information-state">
                  <label htmlFor="user_contact_state">
                    <span className="popup-form__label">都道府県</span>
                  </label>
                  <div className="request-select__area">
                    <span className="service-select">
                      <SMFormSelectBox name="contact[state]" items={states} options={{className: 'service-select__purpose'}} />
                    </span>
                  </div>
                </div>
                <div className="information-city">
                  <label>
                    <span className="popup-form__label">市区町村</span>
                    <input placeholder="新宿区" type="text" name="contact[city]" id="user_contact_city" className="form-text servicse-form-text w100pa" />
                  </label>
                  <SMFormValidationMessage name="contact[city]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.city", this.state.errors)} />
                </div>
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">町名・番地</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input placeholder="西新宿6-15-1 " type="text" name="contact[address_1]" id="user_contact_address_1" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="contact[address_1]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.address_1", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__optional">任意</span>
                  <span className="popup-form__title-text">ビル名・部屋番号</span>
                </h2>
              </div>
              <div className="col-md-9">
                <input placeholder="セントラルパークタワー ラ・トゥール新宿 608" type="text" name="contact[address_2]" id="user_contact_address_2" className="form-text servicse-form-text w100pa" />
                <SMFormValidationMessage name="contact[address_2]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.address_2", this.state.errors)} />
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">電話番号</span>
                </h2>
              </div>
              <div className="col-md-9">
                <div className="information-name sm-information__w100pa">
                  <label>
                    <span className="popup-form__label">ハイフンなしの半角数字</span>
                    <input placeholder="0312345678" type="text" name="contact[tel]" id="user_contact_tel" className="form-text servicse-form-text" />
                  </label>
                  <SMFormValidationMessage name="contact[tel]" withIcon={true} errorText={SMFormatHelper.errorText("User", "contact.tel", this.state.errors)} />
                </div>
              </div>
            </div>
            <div className="odd-col__line clearfix">
              <div className="col-md-3">
                <h2 className="popup-form__title">
                  <span className="icon-form icon-form__required">{I18n.t('service.label_000503')}</span>
                  <span className="popup-form__title-text">業種・職種</span>
                </h2>
              </div>
              <div className="col-md-9">
                <div className="information-name sm-information__w100pa">
                  <label htmlFor="user_contact_industry_id">
                    <span className="popup-form__label">業種</span>
                  </label>
                  <div className="request-select__area">
                    <span className="service-select">
                      <SMFormSelectBox name="contact[industry_id]" items={industries} options={{className: 'service-select__purpose'}} />
                    </span>
                  </div>
                </div>
                <div className="information-name sm-information__w100pa">
                  <label htmlFor="user_contact_job_id">
                    <span className="popup-form__label">職種</span>
                  </label>
                  <div className="request-select__area">
                    <span className="service-select">
                      <SMFormSelectBox name="contact[job_id]" items={jobs} options={{className: 'service-select__purpose'}} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            */}
            {this.renderCertificateUploadField()}
            <div className="odd-col__line clearfix">
              <div className="ta-c mt20 mb20 clearfix">
                <div className="col-xs-12">
                  <input type="submit" name="commit" value={I18n.t('service.label_000502')} className="button-blue pt15 pb15 w200" />
                </div>
              </div>
            </div>
          </div>
        </form>
      );
    }
  }

  renderCertificateUploadField() {
    return(
      <div className="odd-col__line clearfix">
        <div className="col-md-3">
          <h2 className="popup-form__title">
            <span className="icon-form icon-form__optional">{I18n.t('service.label_000506')}</span>
            <span className="popup-form__title-text">{I18n.t('service.label_000507')}</span>
          </h2>
        </div>
        <div className="col-md-9">
          <span className="popup-form__label">{I18n.t('service.text_000506')}</span>
          <input ref="inputFile" type="file" name="certificate" id="files" hidden onChange={this.onFileSelect.bind(this)} />
          <label htmlFor="files" className="button-gray pt10 pb10 w180 mr10">
            <i className="fa fa-paperclip"></i> {I18n.t('service.label_000508')}
          </label>
          <span ref='fileName' className=""></span>
          <SMFormValidationMessage name="certificate" withIcon={true} errorText={SMFormatHelper.errorText("User", "certificate", this.state.errors)} />
        </div>
      </div>
    );
  }

  render() {
    const reservation = this.props.reservation;
    const room = reservation.room;
    const user = reservation.user;
    const states = this.props.states.map((state) => {
      return {value: state.name, label: state.name_text};
    });
    const industries = this.props.industries.map((industry) => {
      return {value: industry.name, label: industry.name_text};
    });
    const jobs = this.props.jobs.map((job) => {
      return {value: job.name, label: job.name_text};
    });

    return (
      <div className="page__popup">
        <div className="page__popup-col1">
          <div className="popup-headline">
            <h2 className="popup-headline__title">
              <img src={user.profile_image} alt={user.name} className="popup-headline__requester-img" />
              <a href={Routes.user_path(user.username)}>{user.name}</a>{I18n.t('service.label_000509')}
              {this.renderCorpName()}{I18n.t('service.label_000510')}<br />
              {I18n.t('service.text_000507')}
            </h2>
            <p className="popup-headline__text">{I18n.t('service.text_000508')}<br className="sm-hide" />{I18n.t('service.text_000509')}</p>
          </div>

          <div className="reserve-detail__box clearfix">
            <div className="row">
              <div className="col-md-2 col-xs-12">
                <div className="reserve-detail__img">
                  <img src={SMFormatHelper.roomImageURL(room, {width: 300, height: 300})} alt={SMFormatHelper.roomNameWithSpace(room)} className="reserve-detail__img-img" />
                </div>
              </div>
              <div className="col-md-10 col-xs-12">
                <h3 className="reserve-detail__name"><a href={Routes.space_room_path(room.space.username, room.uid)}>{SMFormatHelper.roomNameWithSpace(room)}</a></h3>
                <div className="reserve-detail__content">
                  <div className="row reserve-detail__date">
                    <div className="clearfix">
                      <div className="col-xs-5">
                        <p className="reserve-detail__date-title">{I18n.t('service.label_000511')}</p>
                        <p className="reserve-detail__date-content">
                          <span className="reserve-detail__date-detail">{I18n.l("date.y", reservation.stay_checkin_at)}</span>
                          <span className="reserve-detail__date-detail">{I18n.l("date.mdw", reservation.stay_checkin_at)}</span>
                          <span className="reserve-detail__date-detail">{I18n.l("date.hm", reservation.stay_checkin_at)}</span>
                        </p>
                      </div>
                      <div className="col-xs-2 ta-c">
                        <span className="reserve-detail__arrow reserve-detail__date-to">{I18n.t('service.label_000510')}</span>
                      </div>
                      <div className="col-xs-5">
                        <p className="reserve-detail__date-title">{I18n.t('service.label_000512')}</p>
                        <p className="reserve-detail__date-content">
                          <span className="reserve-detail__date-detail">{I18n.l("date.y", reservation.stay_checkout_at)}</span>
                          <span className="reserve-detail__date-detail">{I18n.l("date.mdw", reservation.stay_checkout_at)}</span>
                          <span className="reserve-detail__date-detail">{I18n.l("date.hm", reservation.stay_checkout_at)}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.renderSigninForm()}
          {this.renderRegisterForm()}
        </div>
      </div>
    );
  }

}
export default SMReservationInvitationView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationInvitationView.jsx